<template>
  <div class="report-filters">
    <div v-click-outside="closeFilters">
      <div class="filter-wrap">
        <div class="filter-button-wrap">
          <span class="filter-button" @click="toggleFilters">
            Filter
            <i class="arrow-drop-down"></i>
          </span>
        </div>
        <div class="filter-tags-wrapper">
          <div class="tag-wrapper" v-if="getSelectedOptions('siteIdIn').length > 0">
            <CCFilterTag               
              :options="getOptions('siteIdIn')"
              :selectedOptions="getSelectedOptions('siteIdIn')"
              :title="'Site'"
              @apply="setSelectedOptionsAndApply('siteIdIn', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('sourceIdIn').length > 0">
            <CCFilterTag               
              :options="getOptions('sourceIdIn')"
              :selectedOptions="getSelectedOptions('sourceIdIn')"
              :title="'Site'"
              @apply="setSelectedOptionsAndApply('sourceIdIn', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('marketIdIn').length > 0">
            <CCFilterTag               
              :options="getOptions('marketIdIn')"
              :selectedOptions="getSelectedOptions('marketIdIn')"
              :title="'Site'"
              @apply="setSelectedOptionsAndApply('marketIdIn', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('deviceIdIn').length > 0">
            <CCFilterTag             
              :options="getOptions('deviceIdIn')"
              :selectedOptions="getSelectedOptions('deviceIdIn')"
              :title="'Device'"
              @apply="setSelectedOptionsAndApply('deviceIdIn', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('campaignName', '').length > 0">
            <CCFilterTagInput               
              :value="getSelectedOptions('campaignName', '')"
              :headerLabel="'Campaign'"
              @apply="setSelectedOptionsAndApply('campaignName', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('adGroupName', '').length > 0">
            <CCFilterTagInput               
              :value="getSelectedOptions('adGroupName', '')"
              :headerLabel="'AdGroup'"
              @apply="setSelectedOptionsAndApply('adGroupName', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('boughtClicksGte') > 0">
            <CCFilterTagInput               
              :value="getSelectedOptions('boughtClicksGte')"
              :headerLabel="'Clicks Bought &amp; Higher'"
              @apply="setSelectedOptionsAndApply('boughtClicksGte', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('soldClicksGte') > 0">
            <CCFilterTagInput               
              :value="getSelectedOptions('soldClicksGte')"
              :headerLabel="'Clicks Sold &amp; Higher'"
              @apply="setSelectedOptionsAndApply('soldClicksGte', $event)"            
            />
          </div>
          <div class="tag-wrapper" v-if="getSelectedOptions('profitGte', null) !== null">
            <CCFilterTagInput               
              :value="getSelectedOptions('profitGte', null)"
              :headerLabel="'Profit'"
              @apply="setSelectedOptionsAndApply('profitGte', $event)"            
            />
          </div>
          <div class="tag-wrapper">
            <CCFilterTagInput 
              v-if="getSelectedOptions('opCtrInRange')[0] !== null || getSelectedOptions('opCtrInRange')[1] !== null"
              :value="{min: getSelectedOptions('opCtrInRange')[0], max: getSelectedOptions('opCtrInRange')[1]}"
              :multiple="true"
              :headerLabel="'opCTR Range'"
              @apply="setSelectedOptionsAndApply('opCtrInRange', [$event.min, $event.max])"            
            />
          </div>
          <div class="tag-wrapper">
            <CCFilterTagInput 
              v-if="getSelectedOptions('rpcInRange')[0] !== null || getSelectedOptions('rpcInRange')[1] !== null"
              :value="{min: getSelectedOptions('rpcInRange')[0], max: getSelectedOptions('rpcInRange')[1]}"
              :multiple="true"
              :headerLabel="'RPC Range'"
              @apply="setSelectedOptionsAndApply('rpcInRange', [$event.min, $event.max])"            
            />
          </div>
        </div>
        <Calendar @apply="setDateRanges" :periods="datePeriods" :comparable="true"></Calendar>
      </div>

      <div class="filtersList" v-show="filtersShown">
        <div v-show="filtersShown" class="filters-wrapper">          
          <div class="filtersBlock">
            <div class="filter-block-wrapper">
              <MultiSelect
                :title="'Site'"
                :options="getOptions('siteIdIn')"
                :selectedOptions="getSelectedOptions('siteIdIn')"
                @apply="setSelectedOptions('siteIdIn', $event)"                
              />
            </div>
            <div class="filter-block-wrapper">
              <MultiSelect
                :title="'Source'"
                :options="getOptions('sourceIdIn')"
                :selectedOptions="getSelectedOptions('sourceIdIn')"
                @apply="setSelectedOptions('sourceIdIn', $event)"                
              />
            </div>
            <div class="filter-block-wrapper">
              <MultiSelect
                :title="'Market'"
                :options="getOptions('marketIdIn')"
                :selectedOptions="getSelectedOptions('marketIdIn')"
                @apply="setSelectedOptions('marketIdIn', $event)"                
              />
            </div>
            <div class="filter-block-wrapper">
              <MultiSelect
                :title="'Device'"
                :options="getOptions('deviceIdIn')"
                :selectedOptions="getSelectedOptions('deviceIdIn')"
                @apply="setSelectedOptions('deviceIdIn', $event)"                
              />
            </div>            
          </div>
          <div class="advanced-filters-toggle" v-bind:class="{'open': advancedFiltersShown}" @click="toggleAdvancedFilters">
            <span>
              Advanced Filter
              <i class="advanced-filter-icon-toggle" v-bind:class="{'open': advancedFiltersShown}"></i>
            </span>
          </div>
          <transition name="fade">
            <div class="advanced-filters-wrapper" v-show="advancedFiltersShown">
              <div class="block-wrapper">                
                <!-- <div>
                  <span>Report view</span>
                  <CCSwitchToggle :action="" textBefore="CPC" textAfter="eCPM"></CCSwitchToggle>
                </div> -->
              </div>
              <div class="block-wrapper">
                <div>
                  Campaign
                  <div>
                      <input 
                        type="text" 
                        :value="getSelectedOptions('campaignName', '')"
                        @input="setSelectedOptions('campaignName', $event.target.value)"
                        class="input-text-long"
                      />
                  </div>
                </div>
                <div>
                  AdGroup
                  <div>
                      <input
                        type="text" 
                        :value="getSelectedOptions('adGroupName', '')"
                        @input="setSelectedOptions('adGroupName', $event.target.value)"
                        class="input-text-long"
                      />
                  </div>
                </div>
              </div>
              <div class="block-wrapper">
                <div>
                  Clicks Bought &amp; Higher
                  <div>
                    <input 
                      type="text" 
                      :value="getSelectedOptions('boughtClicksGte', 0)"
                      @input="setSelectedOptions('boughtClicksGte', $event.target.value, 'Int')"
                    >
                  </div>
                </div>
                <div>
                  Clicks Sold &amp; Higher
                  <div>
                    <input 
                      type="text" 
                      :value="getSelectedOptions('soldClicksGte', 0)"
                      @input="setSelectedOptions('soldClicksGte', $event.target.value, 'Int')"
                    >
                  </div>
                </div>                
                <div>
                  Profit &amp; Higher
                  <div>
                    <input 
                      type="text" 
                      :value="getSelectedOptions('profitGte', null)"
                      @input="setSelectedOptions('profitGte', $event.target.value, 'Float')"
                    >
                  </div>
                </div>
                <div>
                  opCTR Range %
                  <div>
                    <input
                      type="text" 
                      :value="getSelectedOptions('opCtrInRange.0', null)"
                      @input="setSelectedOptions('opCtrInRange', [$event.target.value, getSelectedOptions('opCtrInRange.1', null)])"
                    >
                    <input
                      type="text" 
                      :value="getSelectedOptions('opCtrInRange.1', null)"
                      @input="setSelectedOptions('opCtrInRange', [getSelectedOptions('opCtrInRange.0', null), $event.target.value])"
                    >
                  </div>
                </div>
                <div>
                  RPC Range $
                  <div>
                    <input
                      type="text" 
                      :value="getSelectedOptions('rpcInRange.0', null)"
                      @input="setSelectedOptions('rpcInRange', [$event.target.value, getSelectedOptions('rpcInRange.1', null)])"
                    >
                    <input
                      type="text" 
                      :value="getSelectedOptions('rpcInRange.1', null)"
                      @input="setSelectedOptions('rpcInRange', [getSelectedOptions('rpcInRange.0', null), $event.target.value])"
                    >
                  </div>
                </div>                
              </div>
            </div>
          </transition> 
          <div class="filters-bottom-wrapper">
            <div>
              <button @click="onCancel">Cancel</button>
              <button class="apply-button" @click="onApply">Apply</button>
            </div>
          </div>         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

import MultiSelect from "@/components/common/multiselect/v1/MultiSelect";
import CCFilterTag from "@/components/common/tagMultiselect/v1/TagMultiselect.vue";
import CCFilterTagInput from "@/components/common/tagInput/v1/TagInput";
import Calendar from "@/components/common/calendar/v2/Calendar";
import CCSwitchToggle from "@/components/common/switcher/v1/Switcher";
import CCSelect from "@/components/common/CCSelect";

import storeMixin from '@/components/mixins/storeMixin.js';


export default {
  name: "adGroupReportFilters",

  mixins: [
    storeMixin
  ],

  components: {
    MultiSelect,
    CCFilterTag,
    CCFilterTagInput,
    Calendar,
    CCSwitchToggle,
    CCSelect
  },

  props: {
    namespace: {
      type: String,
      required: true
    }
  },

  data() {
    return {
        filtersStatus: 'empty',
        filtersShown: false,
        advancedFiltersShown: false,
        //campaignName: ''
    };
  },

  created() {
    if( this.datePeriods.length === 0 ) {
      this.setSelectedOptions('dateRangesIn', [[ moment().add(-1, 'day').format('YYYY-MM-DD'), moment().add(-1, 'day').format('YYYY-MM-DD') ]]);
    }
  },

  computed: {

    filters: function(){ 
      return this.nsStoreGetter('filters');
    },

    selectedFilters: function(){ 
      return this.nsStoreGetter('selectedFilters');
    },

    datePeriods: function(){ 
      let dateRangesIn = this.getSelectedOptions('dateRangesIn');
      let datePeriods = [];
      dateRangesIn.map( dateRange => datePeriods.push({start: moment(dateRange[0]), end: moment(dateRange[1])}));
      return datePeriods;
    },
  },

  methods: {
    
    onCancel() {
      this.closeFilters();
    },

    onApply() {
      this.$emit('apply');
      this.closeFilters();
    },

    toggleAdvancedFilters() {
      this.advancedFiltersShown = !this.advancedFiltersShown;
    },

    toggleFilters() {
        this.filtersShown = !this.filtersShown;
    },

    closeFilters() {
        this.filtersShown = false;
    },

    setDateRanges(dateRanges) {
      let dateRangesIn = [];
      _.each(dateRanges, dateRange => dateRangesIn.push([dateRange.start.format('YYYY-MM-DD'), dateRange.end.format('YYYY-MM-DD')]));      
      this.setSelectedOptions('dateRangesIn', dateRangesIn);
      this.$emit('apply');
    },

    getOptions(type) {
      if( this.filtersStatus == 'empty' ) {
        this.loadFilters();
      }
      return this.filters[type] || [];
    },

    getSelectedOptions(type, defaultValue = []) {
      return _.get(this.selectedFilters, type, defaultValue);
    },

    setSelectedOptions(type, value, valueType = null) {
      switch(type) {
        case 'campaignName':
        case 'adGroupName':
          if( value === null ) value = '';
          break;
        case 'profitGte':
          if( _.isString(value) && value.length === 0 ) value = null;
          break;
        case 'opCtrInRange':
        case 'rpcInRange':
          value = _.map(value, v => _.isString(v) && v.length === 0 ? null : v);
          break;
      }
      this.nsStoreDispatch('setSelectedFilter', { [type] : value})
    },

    setSelectedOptionsAndApply(type, value, valueType = null) {
      this.setSelectedOptions(type, value, valueType);
      this.onApply();
    },

    loadFilters() {
      let self = this;
      this.filtersStatus = 'loading';
      this.nsStoreDispatch('loadFilters').finally(r => self.filtersStatus = 'loaded');
    },

    filterValue(value, valueType) {
      switch(valueType) {
        case 'Int':
          value = parseInt(value);
          if( _.isNaN(value) ) value = 0;
          break;

        case 'Float':
          value = parseFloat(value);
          if( _.isNaN(value) ) value = 0;
          break; 
      }

      return value;
    }
  }
};
</script>

<style lang="scss" scoped>
.filters-wrapper {
  border: 1px solid $border-color;
  border-radius: $border-radius;
  box-shadow: 1px 3px 7px 1px #cbcccd;
}

.advanced-filters-toggle {
  padding-bottom: 15px;
  border-bottom: 1px solid $border-color;

  &.open {
    border-bottom: 0;
  }

  & > span {
    cursor: pointer;
  }

  .advanced-filter-icon-toggle {
    display: inline-block;
    width: 0.65em;
    height: 0.65em;
    margin-right: 5px;
    margin-left: 5px;
    background-image: url("/static/img/icon-toggle-bottom.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    &.open {
      background-image: url("/static/img/icon-toggle-top.svg");
    }
  }
}

.advanced-filters-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  & > div.block-wrapper {
    padding: 25px;
    text-align: left;
    border: 1px solid $border-color;
    border-radius: $border-radius;
    border-right: 0;

    & > div {
      text-align: left;
      margin-top: 25px;
      margin-bottom: 25px;

      & > div {
        margin-top: 10px;

        & > input {
          max-width: 75px;
          padding: 7px 5px 7px 0;
          border: 1px solid $border-color;
          border-radius: 3px;
          text-indent: 5px;
          text-align: center;

          &.input-text-long {
            max-width: 100%;
            width: 100%;
            text-align: left;
          }
        }
      }
    }

    & > div:first-child {
      margin-top: 0;
    }

    & > div:last-child {
      margin-bottom: 0;
    }

    & > .select-wrapper {
      text-align: center;

      & > div {
        margin-top: 15px;

        & > select {
          min-width: 50%;
        }
      }
    }
  }

  & > div:first-child {
    border-left: 0;
  }
}

.filters-bottom-wrapper {
  text-align: right;
  margin-right: 25px;
  padding: 10px 0 10px 0;

  & > div > button {
    background-color: #fff;
    color: #676767;
    padding: 10px 25px;
    border: 1px solid $border-color;
    border-radius: 3px;

    &.apply-button {
      color: #fff;
      background-color: #4a90e2;
      border: 1px solid #3376c5;
      cursor: pointer;
    }
  }

  & > div > button:first-child {
    margin-right: 15px;
  }
}

.report-filters {
  margin-bottom: 10px;
  width: 100%;
}

.filter-wrap {
  display: grid;
  grid-template-columns: 90px 5fr auto;
}

.filter-tags-wrapper {
  text-align: left;
}

.filter-button-wrap {
  text-align: left;

  .filter-button {
    display: inline-block;
    padding: 5px 8px;
    color: #797979;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid $border-color;
    border-radius: 3px;
    cursor: pointer;

    & > .arrow-drop-down {
      display: inline-block;
      width: 0.65em;
      height: 0.65em;
      margin-right: 5px;
      margin-left: 5px;
      background-image: url("/static/img/icon-filter-dropdown.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
}

.filtersList {
  position: absolute;
  z-index: 999;
  background-color: #fff;
}

.filtersBlock {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  padding: 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@include desktop-and-below {
  .filtersBlock {
    grid-template-columns: repeat(3, 1fr);
  }
}

@include tablet-landscape-and-below {
  .filtersBlock {
    grid-template-columns: repeat(2, 1fr);
  }
}

@include mobile-only {
  .filtersList {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: block;
    margin-right: 0;
    z-index: 10;
    width: 100vw;
  }

  .mobile-actions-wrapper {
    padding-top: 15px;
    background-color: #4a90e2;
    padding-bottom: 15px;
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: end;
    position: sticky;
    z-index: 999;

    & > span {
      color: #fff;
    }

    & > span > i.close-form {
      display: inline-block;
      width: 1.15em;
      height: 1.15em;
      background-image: url("/static/img/icon-close.svg");
      background-repeat: no-repeat;
      background-position: left center;
      background-size: contain;
    }

    & > span:first-child {
      margin-left: 15px;
    }

    & > span:last-child {
      margin-right: 15px;
    }
  }

  .filters-wrapper {
    border: 0;
  }

  .advanced-filters-wrapper {
    grid-template-columns: auto;

    & > div.block-wrapper {
      padding: 5px;
      margin-right: 5px;
      margin-left: 5px;
      border: 0;

      & > div {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;

        & > div {
          margin-top: 0;
        }
      }
    }
  }

  .advanced-filters-toggle {
    border-bottom: 0;
  }

  .filtersBlock {
    grid-template-columns: 1fr;
    padding-top: 15px;
    padding-left: 4px;
    padding-right: 5px;
    grid-gap: 10px;
  }

  .filter-button-wrap {
    display: none;
  }

  .filter-tags-wrapper {
    display: none;
  }

  .report-filters {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .mobile-wrapper {
    display: grid;
    grid-template-columns: 45px auto 45px;

    & > .label {
      margin: auto 0;
      max-width: 70vw;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      & > span {
        font-size: 16px;
      }
    }
  }

  .mobile-filters {
    display: inline-block;
    width: 1.25em;
    height: 1.25em;
    margin-right: 5px;
    margin-left: 5px;
    background-image: url("/static/img/icon-mobile-filters.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .mobile-search {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    margin-right: 5px;
    margin-left: 5px;
    background-image: url("/static/img/filters-search-icon.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .search-input-wrapper {
    display: grid;
    grid-template-columns: 1fr auto;
    margin-left: 15px;
    margin-right: 15px;

    & > input {
      margin-right: 20px;
      border: 1px solid $border-color;
      border-radius: 5px;
      text-indent: 1em;
      padding: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reports/adgroupReport2/Filters.vue